import { render, staticRenderFns } from "./DashHeaderCards.vue?vue&type=template&id=9d8e3ef0&scoped=true&"
import script from "./DashHeaderCards.vue?vue&type=script&lang=js&"
export * from "./DashHeaderCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8e3ef0",
  null
  
)

export default component.exports